// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GroupedPoseTiles_wrapper__PhAW4","list":"GroupedPoseTiles_list__y9cxj"};